<div class="container-tablet">
  <div class="d-flex w-100 align-items-center justify-content-center"></div>

  <div class="mb-3 d-flex">
    <div
      class="col-2 d-flex align-items-center justify-content-center"
      routerLink="/routines-tablet"
    >
      <i class="bi bi-arrow-left-circle-fill" style="font-size: 32px"></i>
    </div>

    <div class="d-flex col-8 text-center">
      <span class="title">Rutina de &nbsp;</span
      ><span class="title fw-bold">{{ tabletRoutine.name }}</span>
    </div>
  </div>

  <div class="" *ngIf="routine">
    <div
      class="exercise"
      *ngFor="let exerciseGroup of exercisesByExerciseGroup"
    >
      <div
        class="set-type d-flex justify-content-center align-items-center col-5 ms-1 mt-2"
        *ngIf="exerciseGroup.length > 1"
      >
        <span class="set-text d-flex" *ngIf="exerciseGroup.length == 2"
          >Superserie</span
        >
        <span class="set-text" *ngIf="exerciseGroup.length == 3">Triserie</span>
        <span class="set-text" *ngIf="exerciseGroup.length > 3"
          >Serie Gigante</span
        >
      </div>
      <div
        class=""
        *ngFor="let exercise of exerciseGroup"
        (click)="openVideoModal(exercise)"
      >
        <span class="exercise-title">{{ exercise.exercise!.name }}</span>
        <div class="d-flex">
          <i class="bi bi-caret-right-fill exercise-icon"></i>
          <span class="exercise-reps">{{ exercise.summary }}</span>
        </div>
        <div class="d-flex">
          <span
            *ngFor="let ip of exercise.intensityPrinciples"
            class="intensity-principle"
            >{{ ip }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bottom-part p-4">
  <button class="btn-custom-outline w-100" (click)="finishRoutine()">
    Finalizar Rutina!
  </button>
</div>

<app-video-modal></app-video-modal>
